export enum Children {
	preschool = "子ども（未就学児/0歳～6歳）",
	elementarySchool = "子ども（小学生/6歳～12歳）",
	juniorHighSchool = "子ども（中学生/12歳～15歳",
	highSchool = "子ども（高校生/15歳～18歳）",
	university = "子ども（大学生以上/18歳以上）",
}
